import { IGroupCounterView, IGroupEvent, EventType } from 'APP/model/counter/counterModel.types';
import {
  IMessage,
  IMessagePayload,
  IRepliedMessageData,
} from 'APP/model/message/messageModel.types';

export function mapMessageResponse(message: any): IMessage {
  return {
    ...message,
    payload: message.payload as IMessagePayload,
    repliedMessage: message.quotedMessage as IRepliedMessageData,
  };
}

export function mapCounterResponse(counter: any): IGroupCounterView {
  return {
    counter: Number(counter.counter),
    groupId: counter.groupId,
    lastEvent: counter.lastEvent ? mapGroupEvent(counter.lastEvent) : undefined,
    lastEventTs: counter.lastEventTs ? Number(counter.lastEventTs) : undefined,
    lastMessage: counter.lastMessage ? mapMessageResponse(counter.lastMessage) : undefined,
    lastMessageTs: counter.lastMessageTs ? Number(counter.lastMessageTs) : undefined,
    lastUserMentionTs: Number(counter.lastUserMentionTs),
    opponentSeenTs: counter.opponentSeenTs ? Number(counter.opponentSeenTs) : undefined,
    previousEventTs: counter.previousEventTs ? Number(counter.previousEventTs) : undefined,
    previousMessageTs: counter.previousMessageTs ? Number(counter.previousMessageTs) : undefined,
    seenTs: Number(counter.seenTs),
    totalMessagesCount: counter.totalMessagesCount ? Number(counter.totalMessagesCount) : undefined,
    unreadUserMentionsCounter: Number(counter.unreadUserMentionsCounter),
    clearHistoryTs: Number(counter.clearHistoryTs),
    updatedTs: counter.updatedTs ? Number(counter.updatedTs) : undefined,
  };
}

export function mapGroupEvent(groupEvent: any): IGroupEvent {
  return {
    ...groupEvent,
    type: groupEvent.type as EventType,
    ts: Number(groupEvent.ts),
  };
}
